import { z } from "zod";
// FR-003: shape of a row from public.v_tariff_pairs view.
// Columns are snake_case in SQL; we keep them as-is on the DTO and convert
// to TariffPairDom (advance/late TariffDom objects) via the pair mapper.
export const zTariffPairRowDto = z.object({
    id_advance: z.string(),
    id_service_zone: z.string(),
    name: z.string(),
    type: z.string(),
    valid_from: z.string(),
    valid_to: z.string().nullish(),
    is_active: z.boolean(),
    is_default: z.boolean(),
    is_deleted: z.boolean().nullish(),
    advance_price_per_kwh: z.number().nullish(),
    advance_one_time_fee: z.number(),
    advance_emergency_fee: z.number().nullish(),
    late_price_per_kwh: z.number().nullish(),
    late_one_time_fee: z.number().nullish(),
    late_emergency_fee: z.number().nullish(),
    cutoff_hour_msk: z.number().int().nullish(),
    cutoff_offset_days: z.number().int().nullish(),
    id_late_tariff: z.string().nullish(),
    subscription_price: z.number().nullish(),
    subscription_duration_days: z.number().int().nullish(),
    subscription_kwh_limit: z.number().nullish(),
    subscription_visit_limit: z.number().int().nullish(),
    rollover_type: z.string().nullish(),
    over_limit_price_per_kwh: z.number().nullish(),
    over_limit_visit_price: z.number().nullish(),
    created_at: z.string().nullish(),
    updated_at: z.string().nullish(),
});
